<template>
 <section class="lymphomap_main">
    <div class="container-fluid">
      <div class="appointment_list_header_wrp">
        <div class="row align-items-center">
          <div class="col">
            <h1 class="appointment_list_heading">
              <router-link class="btn back_btn" to="/admin/">
                <i aria-hidden="true" class="fa fa-chevron-left"></i>
              </router-link> FAQ Feedbacks
            </h1>
          </div>
        <div class="col-auto ml-auto select_items_delete_btn">
          <router-link to="/admin/" class="btn btn-primary">Admin</router-link>
        </div>
        </div>
      </div>
      <div class="appointment_list_body_wrp">
        <table class="table" v-if="feedBackList">
          <thead>
            <tr>
              <th>Users</th>
              <th class="text-center">Suggestions</th>
              <th class="text-right">Date</th>
            </tr>
            <tr class="empty_cell">
              <th colspan="3"></th>
            </tr>
          </thead>
          <tbody v-if="feedBackListResults.length > 0">
            <tr v-for="item in feedBackListResults" :key="item.id">
              <td> {{ item.first_name }} {{ item.last_name }}
                  <div class="dctr_slctd_cat">
                      <span class="dctr_reg_num">Email: {{item.email}}</span>
                  </div>
              </td>
              <td class="text-center">{{ item.description }}</td>
              <td class="text-right">{{ item.created_at | LocalDateFormat }} at {{ item.created_at | LocalTimeFormat }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="3" class="text-center">You don't have any feedbacks</td>
            </tr>
          </tbody>
        </table>
        <div class="compontent-loader" v-else>
          <div class="spinner"></div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
/* eslint-disable */
import {mapGetters} from 'vuex';
export default {
  props: [],
  name:"demo-request-feedback-list",
  components: {
  },
  data() {
    return {
      feedBackList: null,
      feedBackListResults: []
    };
  },
  computed: {
    ...mapGetters([
      'getAllFAQFeedbackListGetter',
    ]),
    getAllDemoRequestListMethod(){
      this.feedBackList = this.$store.getters.getAllFAQFeedbackListGetter.data;
      return;
    },
    setInitialStates(){
      if(this.feedBackList){
        this.feedBackListResults = this.feedBackList.results;
      }
    }
  },
  mounted() {
    this.getAllDemoRequestListMethod;
    this.setInitialStates;
  },
  watch: {
    getAllDemoRequestListMethod(){
      return this.$store.getters.getAllFAQFeedbackListGetter;
    },
    setInitialStates(){
      if(this.feedBackList){
        this.feedBackListResults = this.feedBackList.results;
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.lymphomap_main {
  .appointment_list_header_wrp {
    padding-bottom: 25px;

    .back_btn {
      border-radius: 35px;
      padding: 0;
      margin-right: 5px;
      font-size: 16px;
      display: inline-block;
      vertical-align: text-bottom;
      line-height: 32px;
      width: 32px;
      height: 32px;
      outline: none !important;
      -webkit-box-shadow: none !important;
      box-shadow: none !important;
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
      &:hover{
        background: #87cefa;
        color: #000000;
      }
    }

    .appointment_list_heading {
      color: #fff;
      font-size: 24px;
      text-transform: uppercase;
      font-weight: 700;
      margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    }
    .select_items_delete_btn {
        .btn-primary {
            cursor: pointer;
            position: relative;
            min-width: 95px;
            -webkit-box-shadow: none;
            box-shadow: none;
            outline: none;
            background: #b41818;
            color: #fffcc4;
            border: none;
            border-radius: 3px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            font-size: 16px;
            line-height: 35px;
            padding: 0px 12px;
            outline: none !important;
            box-shadow: none !important;

            &:hover {
                background: #87cefa;
                color: #000;
                border-color: #87cefa;
            }
        }
    }
  }

  .appointment_list_body_wrp {
    .table {
      margin: 0px;
      letter-spacing: 0.5px;
      color: #ffffff;
      border-collapse: separate;
      border-spacing: 0 3px;

      thead {
        th {
          border-bottom: 0;
          font-size: 19px;
          padding: 10px 8px;
          font-family: 'MyriadProRegular', sans-serif;
          text-transform: uppercase;
          border-top: 0;
          transition: all .5s ease;
          -webkit-transition: all .5s ease;
          -moz-transition: all ease .5s;
          background: rgba(228, 233, 237, .1);
          color: #87cefa;
        }

        .empty_cell th {
          padding: 0px !important;
          background: none !important;
        }
      }

      tbody {
        td {
          color: #fff;
          vertical-align: middle;
          padding: 10px 8px;
          font-size: 20px;
          font-family: 'MyriadProRegular', sans-serif;
          transition: all .5s ease;
          -webkit-transition: all .5s ease;
          -moz-transition: all ease .5s;
          height: 70px;
          line-height: 1.3;
          border-top: 0;
          background: rgba(228, 233, 237, .1);

          &.symptoms_item span:last-child i {
            display: none;
          }

          a {
            color: #fff;
            text-decoration: none;

            &:hover {
              color: #ffd400;
            }
          }
        }
      }
    }
    @media only screen and (max-width: 767px) {
       .table{
        thead{display: none !important;}
        tbody{
            tr{
                display: block !important;
                border-bottom: 1px solid rgba(255,255,255,0.1) !important;
                padding: 10px 0 !important;
                background: rgba(228, 233, 237, 0.1);
                &:last-child{
                    border-bottom: none !important;
                }
                td{
                    display: block !important;
                    border: none !important;
                    padding:1px 5px !important;
                    background: none !important;
                    font-size: 16px;
                    height: auto !important;
                    text-align: left !important;
                }
            }
        }
       }
    }
  }

  .status_btn_wrp {
    .btn {
      padding: 8px 10px;
      line-height: 1;
      outline: none !important;
      box-shadow: none !important;
    }
  }

  .btn-danger {
    &:hover {
      background: #87cefa;
      color: #000 !important;
      border-color: #87cefa;
    }
  }

  .payment_status_text {
    font-size: 16px;
    display: block;
    color: #ffd400;
    margin-top: 4px;
  }

  .payment_inpro_btn {
    background: #ffd400 !important;
    border: none !important;
    color: #000 !important;

    &:hover {
      background: #87cefa !important;
    }
  }

  @media only screen and (max-width:767px) {
    .container-fluid {
      padding: 0px;
    }
  }
}
.dctr_slctd_cat{
    span{
        background: #261139;
        padding: 1px 12px 2px;
        line-height: 1;
        border-radius: 20px;
        font-size: 14px;
        color: #a560e8;
        text-transform:capitalize;
    }
}
</style>